import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class OfferService {
  constructor(private baseService: BaseService) {}

  getAllOffers(filters?: any): Observable<any> {
    return this.baseService.get('offer/listOffers', undefined, filters);
  }

  getOfferById(id: string): Observable<any> {
    return this.baseService.get('offer/getOffer', id);
  }

  createOffer(data: any): Observable<any> {
    return this.baseService.post('offer/addOffer', data);
  }

  updateOffer(data: any): Observable<any> {
    return this.baseService.post('offer/editOffer', data);
  }

  deleteOffer(id: string): Observable<any> {
    return this.baseService.delete('offer/deleteOffer', id);
  }

  toggleOfferStatus(id: string, isActive: boolean): Observable<any> {
    return this.baseService.patch(`offer/toggleStatus/${id}`, { isActive });
  }

  getActiveOffers(): Observable<any> {
    return this.baseService.get('offer/activeOffers');
  }
}
